import { jsx, Fragment } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from "react";
import useApi from "../hooks/useApi.js";
import { Celebration } from "../pages/Celebration.js";
import { Recommendations } from "../pages/Recommendations.js";
import { ShareAccomplishment } from "../pages/ShareAccomplishment.js";
import { Layout } from "./Layout.js";
import PageLoader from "./PageLoader.js";
const PageComponent = (props) => {
  const {
    dashboardUrl,
    data,
    screen,
    setScreen
  } = props;
  switch (screen) {
    case "celebration":
      return /* @__PURE__ */ jsx(Celebration, { data, setScreen });
    case "recommendations":
      return /* @__PURE__ */ jsx(Recommendations, { dashboardUrl, data });
    case "share":
      return /* @__PURE__ */ jsx(ShareAccomplishment, { setScreen });
    default:
      return /* @__PURE__ */ jsx(Fragment, {});
  }
};
const App = (props) => {
  const {
    baseUrl,
    contentKey,
    contentType,
    dashboardUrl,
    onError
  } = props;
  const [screen, setScreen] = useState("celebration");
  const {
    data,
    error,
    loading,
    ready
  } = useApi(`${baseUrl}/${contentType}/${contentKey}/recommendations/end-of-content`);
  useEffect(() => {
    if (ready && (error || !data)) {
      onError == null ? void 0 : onError(error);
    }
  }, [data, error, onError, ready]);
  const showBackButton = screen === "recommendations";
  if (loading) {
    return /* @__PURE__ */ jsx(Layout, { backButton: showBackButton, dashboardUrl, children: /* @__PURE__ */ jsx(PageLoader, {}) });
  }
  if (error || !data) {
    return /* @__PURE__ */ jsx(Layout, { backButton: showBackButton, dashboardUrl });
  }
  return /* @__PURE__ */ jsx(Layout, { backButton: showBackButton, dashboardUrl, children: /* @__PURE__ */ jsx(PageComponent, { dashboardUrl, data, screen, setScreen }) });
};
export {
  App as default
};
